import React from 'react'
import ComingSoon from './ComingSoon'

export default function AssistantBanner() {
  return (
    <>
      <div className="inicio-assistant">
        <p className="inicio-assistant__title">Henri, tu asistente comercial con IA</p>
        <p className="inicio-assistant__description">
          Analiza tu actividad, identifica qué leads requieren atención y te
          ayuda a cerrar más ventas. Adaptado a tu rol.
        </p>
      </div>
      <ComingSoon />
    </>
  )
}
